import { useSolutionOrg } from '../../config/useSolutionOrg';
import { useLogo } from '../../config/useLogo';
import { getServiceNationSsoToken } from '../../api/loginAPI';
import { HOME_ROUTE } from '../../routes/namedRoutes';

const EMBEDDED_PARAM = 'embedded';

export const useServiceNationUrl = () => {
  const { baseUrl, solutionOrgSpecificAppName } = useSolutionOrg();
  const { secondaryOne: logoUrl } = useLogo();

  // `isEmbedded` marks URLs that are shown in an iframe rather than opened in a new tab
  const buildServiceNationUrl = async (destination: string, isEmbedded = false) => {
    const { token } = await getServiceNationSsoToken();
    const serviceNationBaseUrl = process.env.REACT_APP_SERVICE_NATION_URL ||
      'https://app.servicenation.dev';
    const homeBase = (baseUrl as string) || window.location.origin;
    const logo = (logoUrl as string) || 'https://d2o7bp9oz3gksv.cloudfront.net/login_page_logo_sn_by_ever_Pro_29fb73bc64.png';

    const url = new URL('/edge-auth', serviceNationBaseUrl);
    url.searchParams.set('token', token);
    url.searchParams.set('destination', destination);
    url.searchParams.set('home', new URL(HOME_ROUTE, homeBase).toString());
    url.searchParams.set('logo', logo);
    url.searchParams.set('brand', (solutionOrgSpecificAppName as string) || 'Service Nation');
    if (isEmbedded) url.searchParams.set(EMBEDDED_PARAM, 'true');

    return url.toString();
  };

  return { buildServiceNationUrl };
};
